// import external dependencies
// Polyfills
import 'custom-event-polyfill/polyfill.js';
import 'es6-object-assign/dist/object-assign-auto.js';

import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js';

import './global/nav';
/// #if search === true
import './global/search';
/// #endif

// import local dependencies
import Router from './util/Router';
import common from './routes/common';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
});

// Load Events
jQuery(document).on('ready', () => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js